import { Provider } from '@angular/core';
import { DOSSIER_REPOSITORY } from './repositories/dossie.repository';
import { DossieService } from './services/dossie.service';

export const DOSSIER_PROVIDERS: Provider[] = [
  {
    provide: DOSSIER_REPOSITORY,
    useClass: DossieService
  }
];
